import { render, staticRenderFns } from "./HomeButton.vue?vue&type=template&id=31db6df7"
import script from "./HomeButton.vue?vue&type=script&lang=js"
export * from "./HomeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports